// extracted by mini-css-extract-plugin
export var infoRow = "_rl-2";
export var labelContainer = "_rl-0";
export var rightInfo = "_rl-1";